import React, {Suspense} from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
  Prompt,
} from 'react-router-dom';
import { hiddenRoutes, navbarRoutes } from '../routes';
import NavBar from './navigation/NavBar';
import Title from './Title';
import SpinnerComponent from "./SpinnerComponent/SpinnerComponent";
import LoadingFallback from "./LoadingFallback";
import Invite from '../pages/Invite';

function userSessionTracking() {
  const token = sessionStorage.getItem('kctoken');
  const location = useLocation();
  const section = navbarRoutes.filter((e) => location.pathname === e.path);
  const subSection = navbarRoutes.map((e) => e.subRoutes?.filter((es) => location.pathname === es.path)).filter((e) => e && e?.length !== 0);
  const nameSection = section.length === 1 ? section[0].title : subSection.length === 1 ? subSection[0][0].title : null;
  const info = {
    serviceName: 'priority2030',
    serviceSection: `${nameSection}`,
  };
  nameSection !== null && v(token, info);
}

/**
 * This sends activity info to user profile.
 * @function
 * @param {string} token - users keycloak token
 * @param {object} info - description (serviceName required)
 * {
 * serviceName:'service',
 * serviceSection:'section',
 * actionMessage: 'user enters page',
 * orgInn: 'organization inn',
 * orgTitle: 'organization title',
 * orgPost: 'organization post'
 * }
 */

function v(token, info) {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', 'https://lk-profile-api.my1.urfu.ru/activity');
  xhr.setRequestHeader('Authorization', `Bearer ${token}`);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send(JSON.stringify(info));
}

function mapSwitch(routes) {
  return routes.reduce((acc, route) => {
    const subroutes = route.subRoutes ? mapSwitch(route.subRoutes) : [];
    const currentRoute = route;
    return [...acc, currentRoute, ...subroutes];
  }, []);
}

function RouterView({ userCtx }) {
  const switchContent = mapSwitch([...navbarRoutes, ...hiddenRoutes]).filter(
    (r) => (r.component || r.redirect) && r.path,
  );
  userSessionTracking();
  return (
    <div style={{ width: '100%', paddingLeft: 220, paddingTop: 67 }}>
      <Title />
      <Switch>
        {switchContent.map((route) => {
          if (route.hide && route.hide(userCtx)) return null;
          return (
            <Route
              path={route.path}
              exact={route.exact}
              key={`${route.id}-route`}
              render={(props) => (
                // pass the sub-routes down to keep nesting
                    <route.component
                      key={`${route.id}-route`}
                      {...props}
                      subRoutes={route?.subRoutes?.filter(
                        (s) => !s.hide || !s.hide(userCtx),
                      )}
                    />
              )}
            >
              {route.redirect && (
                <Redirect
                  from={route.path}
                  to={route.redirect}
                  key={`${route.id}-route`}
                />
              )}
            </Route>
          );
        })}
      </Switch>
    </div>
  );
}

export default function AppContainer({ userCtx }) {
  return (
        <Router>
          <Route
            path='/invite'
            component={Invite}
            exact
          />
          <div style={{ display: 'flex' }}>
            <NavBar userCtx={userCtx} />
              <RouterView userCtx={userCtx} />
            {/* <MyPrompt /> */}
          </div>
        </Router>

  );
}

// function MyPrompt() {
//   const [isBlock, setIsBlock] = React.useState(false);
//   const location = useLocation();
//   const pathname = location.pathname;
//   let text = "";
//   React.useEffect(() => {
//     let timer = setTimeout(function f() {
//       if (!Boolean(document.querySelector("textarea")?.value || false)) {
//         setIsBlock(false);
//         timer = setTimeout(f, 1);
//       } else {
//         if (!text) text = document.querySelector("textarea")?.value;
//         if (text != document.querySelector("textarea")?.value) setIsBlock(true);
//         timer = setTimeout(f, 1);
//       }
//     }, 1);

//     return () => {
//       setIsBlock(false);
//       clearTimeout(timer);
//     };
//   }, [pathname]);

//   return (
//     <Prompt
//       when={isBlock}
//       message={() => "Вы точно хотите покинуть страницу?"}
//     />
//   );
// }
